import { PortfolioOccurrence } from './model/portfolio-occurrence.model';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpErrorResponse, HttpEvent, HttpHeaders } from '@angular/common/http';
import { EnvironmentService } from '../core/environment/environment.service';
import { OccurenceType } from './model/occurence-type.model';
import { Occurence } from './model/occurence.model';
import { OccurrencePaginationParameters } from './model/occurrence-pagination-parameters.model';
import { Observable, throwError } from 'rxjs';

import { ComboboxItem } from './model/combobox-item.model';
import { PortfolioItem } from './model/portfolio-item.model';
import { catchError, map } from 'rxjs/operators';
import { OccurenceComments } from '@app/occurences/add-occurence-modal/occurence-list-comments/occurence-comments.interface';
import { UtilService } from '../shared/utils';
import { AuthUser } from '@app/core/auth/auth-frame/auth-user.model';
import { AuthService } from '@app/core/auth/auth.service';
import { ValidatedTokenService } from '@app/shared/services/validated-token/validated-token.service';

@Injectable({
  providedIn: 'root'
})
export class OccurencesService {

  public currentGestorDemanda: string = null;
  private serviceUrl: string = '/occurrences';
  private apiUrl: string;
  private apiUrlMenu: string;
  authUser: AuthUser;
  authSubject: Observable<AuthUser>;
  statusRquest: boolean = true;
  commentsOccurence: any = {
    "occurrence": {
      "id": null
    },
    "description": null,
    "userName": null
  };

  constructor(
    private http: HttpClient,
    private environmentService: EnvironmentService,
    private utils: UtilService,
    private authService: AuthService,
    private validatedTokenService: ValidatedTokenService
  ) {
    this.apiUrl = this.environmentService.envModel.appSettings.apiUrlOccurrence;
    this.apiUrlMenu = this.environmentService.envModel.appSettings.apiUrlMenu;
    this.authSubject = this.authService.getAuthModel();
    this.authSubject.subscribe((user: AuthUser) => {
      this.authUser = user;
    });
  }

  get jwt(): HttpHeaders {
    const headers = new HttpHeaders({ jwt: this.validatedTokenService.jwt })
    return headers
  }

  getOccurenceTypes() {
    return this.http.get<OccurenceType[]>(this.apiUrl + this.serviceUrl + '/occurrenceType');
  }

  getOccurenceList(parameters: OccurrencePaginationParameters) {
    if (parameters != undefined) {
      return this.http.get<any>(this.apiUrl + this.serviceUrl, {
        params: new HttpParams()
          .set('userName', parameters.userName)
          .set('pageIndex', parameters.pageIndex.toString())
          .set('pageSize', parameters.pageSize.toString())
          .set('sortColumn', parameters.sortColumn)
          .set('sortOrder', parameters.sortOrder)
      });
    }
  }

  jsonDataToPortfolios(jsonData: any[]): PortfolioOccurrence[] {
    const portfolios: PortfolioOccurrence[] = [];
    if (jsonData && Array.isArray(jsonData)) {
      jsonData.forEach(element => portfolios.push(element as PortfolioOccurrence));
    }
    return portfolios;
  }

  getOccurenceListPost(parameters: OccurrencePaginationParameters) {
    if (parameters !== undefined) {
      const url = `${this.apiUrl}${this.serviceUrl}/find-by-filters`;
      return this.http.post<any>(url, parameters);
    }
  }

  getOcurrenceById(occurrenceId: number): Observable<Occurence> {
    return this.http.get<Occurence>(this.apiUrl + this.serviceUrl + '/' + occurrenceId, { headers: this.jwt });
  }

  getCommentsByOccurrenceById(occurrenceId: number): Observable<Array<OccurenceComments>> {
    return this.http.get<Array<OccurenceComments>>(this.apiUrl + this.serviceUrl + '/' + occurrenceId + '/comments');
  }

  getHasCommentsByOcurrenceById(occurrenceId: number): Observable<number> {
    return this.http.get<number>(this.apiUrl + this.serviceUrl + '/' + occurrenceId + '/has-comments');
  }

  downloadOcurrenceFileById(documentId: number): Observable<any> {
    return this.http.get
      (
        `${this.apiUrl}${this.serviceUrl}/download/${documentId}`,
        { observe: 'response', responseType: 'json', headers: this.jwt }
      );
  }

  createOccurence(occurence: Occurence, files: Array<File>): Observable<HttpEvent<any>> {
    occurence.fundCnpjCpf = occurence.fundCnpjCpf.replace(/[^\d]+/g, '');
    const formData = this.utils.convertPayloadFileToFormData(occurence, 'occurrence', files);
    return this.http.post<HttpEvent<any>>(this.apiUrl + this.serviceUrl, formData)
      .pipe(
        catchError(this.handleError)
      );
  }

  addCommentsOccurrence(payload: FormData, idOccurrence): Observable<HttpEvent<any>> {

    return this.http.post<HttpEvent<any>>
      (
        `${this.apiUrl}${this.serviceUrl}/${idOccurrence}/comments`,
        payload, { headers: this.jwt }

      )
      .pipe(
        catchError(this.handleError)
      );
  }

  getOccurrenceComments(idOccurrence): Observable<Array<OccurenceComments>> {

    return this.http.get<Array<OccurenceComments>>
      (
        `${this.apiUrl}${this.serviceUrl}/${idOccurrence}/comments`

      )
      .pipe(
        catchError(this.handleError)
      );
  }

  manageReadComment(occurenceComments: OccurenceComments) {
    return this.http.post<OccurenceComments>
      (
        this.apiUrl + this.serviceUrl + '/comments/read',
        occurenceComments, { headers: this.jwt }
      )
      .pipe(
        catchError(this.handleError)
      );
  }

  private handleError(error: HttpErrorResponse) {
    this.statusRquest = false;
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`);
    }
    // return an observable with a user-facing error message
    return throwError(
      'Erro ao enviar demanda.');
  }

  static cpfCnpjValidator(numDoc: string): boolean {
    numDoc = numDoc.replace(/[^\d]+/g, '');
    if (numDoc.length == 11)
      return this.cpf(numDoc);
    else if (numDoc.length == 14)
      return this.cnpj(numDoc);
    return false;
  }

  private static cpf(cpf: string): boolean {

    let numeros, digitos, soma, i, resultado, digitos_iguais;
    digitos_iguais = 1;
    if (cpf.length < 11)
      return false;
    for (i = 0; i < cpf.length - 1; i++)
      if (cpf.charAt(i) != cpf.charAt(i + 1)) {
        digitos_iguais = 0;
        break;
      }
    if (!digitos_iguais) {
      numeros = cpf.substring(0, 9);
      digitos = cpf.substring(9);
      soma = 0;
      for (i = 10; i > 1; i--)
        soma += numeros.charAt(10 - i) * i;
      resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
      if (resultado != digitos.charAt(0))
        return false;
      numeros = cpf.substring(0, 10);
      soma = 0;
      for (i = 11; i > 1; i--)
        soma += numeros.charAt(11 - i) * i;
      resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
      if (resultado != digitos.charAt(1))
        return false;
      return true;
    }
    else
      return false;
  }

  private static cnpj(cnpj): boolean {
    if (cnpj == '') return false;

    if (cnpj.length != 14)
      return false;

    // Elimina CNPJs invalidos conhecidos
    if (cnpj == "00000000000000" ||
      cnpj == "11111111111111" ||
      cnpj == "22222222222222" ||
      cnpj == "33333333333333" ||
      cnpj == "44444444444444" ||
      cnpj == "55555555555555" ||
      cnpj == "66666666666666" ||
      cnpj == "77777777777777" ||
      cnpj == "88888888888888" ||
      cnpj == "99999999999999")
      return false;

    // Valida DVs
    let tamanho = cnpj.length - 2
    let numeros = cnpj.substring(0, tamanho);
    let digitos = cnpj.substring(tamanho);
    let soma = 0;
    let pos = tamanho - 7;
    for (let i = tamanho; i >= 1; i--) {
      soma += numeros.charAt(tamanho - i) * pos--;
      if (pos < 2)
        pos = 9;
    }
    let resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
    if (resultado != digitos.charAt(0))
      return false;

    tamanho = tamanho + 1;
    numeros = cnpj.substring(0, tamanho);
    soma = 0;
    pos = tamanho - 7;
    for (let i = tamanho; i >= 1; i--) {
      soma += numeros.charAt(tamanho - i) * pos--;
      if (pos < 2)
        pos = 9;
    }
    resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
    if (resultado != digitos.charAt(1))
      return false;

    return true;
  }

  downloadDocumentOfCommentById(id: number): Observable<any> {
    return this.http.get
      (
        `${this.apiUrl}${this.serviceUrl}/download/${id}`,
        { observe: 'response', responseType: 'json', headers: this.jwt }
      );
  }

  getStatus(): Observable<ComboboxItem[]> {
    const url = `${this.apiUrl}/occurrences/occurrencesStatus`;
    return this.http.get<ComboboxItem[]>(url).pipe(
      catchError(this.handleError),
      map(this.jsonDataToComboboxItems)
    );
  }

  getPortfolios(): Observable<PortfolioItem[]> {
    const url = `${this.apiUrl}/occurrences/occurrencePortfolios/name`;
    return this.http.get<PortfolioItem[]>(url);
  }

  jsonDataToComboboxItems(jsonData: any[]): ComboboxItem[] {
    const items: ComboboxItem[] = [];
    if (jsonData && Array.isArray(jsonData)) {
      jsonData.forEach(element => items.push(element as ComboboxItem));
    }
    return items;
  }

  getPortfoliosBySearch(keySearch: string, typeSearch: string, pageSize?: number): Observable<any> {
    const apiUrl = this.environmentService.envModel.appSettings.apiUrlMenu;
    const serviceUrl = '/users/portfolio';

    let headers: HttpHeaders = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });

    pageSize = pageSize ? pageSize : 10;
    return this.http.get<any[]>(`${apiUrl}${serviceUrl}`,
      {
        params: {
          search: keySearch,
          typeSearch: typeSearch,
          resultSize: pageSize.toString(),
          manager: this.authUser.gestor
        },
        headers: headers
      }
    );
  }

  getCurrentGestorLogged(): String {
    return this.authUser ? this.authUser.gestor : null;
  }

}
